import type { CalendarView, CommonCalendarOptions } from "../types";
import { endOfDay } from "date-fns/endOfDay";
import { endOfMonth } from "date-fns/endOfMonth";
import { endOfWeek } from "date-fns/endOfWeek";
import { endOfYear } from "date-fns/endOfYear";
import { startOfDay } from "date-fns/startOfDay";
import { startOfMonth } from "date-fns/startOfMonth";
import { startOfYear } from "date-fns/startOfYear";
import { startOfWeek } from "date-fns/startOfWeek";
import { fromZonedTime, toZonedTime } from "date-fns-tz";

export const getRangeFromDateAndView = (
  date: Date,
  view: CalendarView,
  options: CommonCalendarOptions = { weekStart: "sunday" }
): { startDate: Date; endDate: Date } => {
  const timezone = options.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zonedDate = toZonedTime(date, timezone);
  const weekStartsOn = options.weekStart === "monday" ? 1 : undefined;

  const toRange = (start: Date, end: Date) => ({
    startDate: fromZonedTime(start, timezone),
    endDate: fromZonedTime(end, timezone),
  });

  switch (view) {
    case "day":
      return toRange(startOfDay(zonedDate), endOfDay(zonedDate));
    case "week":
      return toRange(startOfWeek(zonedDate, { weekStartsOn }), endOfWeek(zonedDate, { weekStartsOn }));
    case "month":
    case "list":
      return toRange(startOfMonth(zonedDate), endOfMonth(zonedDate));
    case "year":
      return toRange(startOfYear(zonedDate), endOfYear(zonedDate));
  }
};
